import { call, put, select } from 'redux-saga/effects';

import serviceLocator, { DASHBOARD_LITE_SVC } from '../../APIs/common/service-locator';
import {
    fetchPartnerBrokerSuccess,
    fetchPartnerBrokerFail,
} from '../../actions/dashboardLite/dashboardLiteActionCreators';
import { environmentSelector } from '../../selectors/commonSelectors';

export function* fetchPartnerBrokerAsync() {
    try {
        const { encryptedHouseholdId } = yield select(environmentSelector);
        const dashboardLiteService = yield call(serviceLocator, DASHBOARD_LITE_SVC);
        const partnerBrokerData = yield call([dashboardLiteService, dashboardLiteService.fetchPartnerBroker], { encryptedHouseholdId });
        yield put(fetchPartnerBrokerSuccess(partnerBrokerData));
    } catch (e) {
        yield  put(fetchPartnerBrokerFail(e));
    }
}